/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateCustomerSupplyRequest model module.
* @module model/CreateCustomerSupplyRequest
* @version 2020-12-7
*/
export default class CreateCustomerSupplyRequest {
    /**
    * Constructs a new <code>CreateCustomerSupplyRequest</code>.
    * 顧客給油量登録リクエスト
    * @alias module:model/CreateCustomerSupplyRequest
    * @class
    * @param timestamp {Number} 給油時刻
    * @param amount {Number} 給油量
    */

    constructor(timestamp, amount) {
        
        
        this['timestamp'] = timestamp;
        this['amount'] = amount;
        
    }

    /**
    * Constructs a <code>CreateCustomerSupplyRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateCustomerSupplyRequest} obj Optional instance to populate.
    * @return {module:model/CreateCustomerSupplyRequest} The populated <code>CreateCustomerSupplyRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateCustomerSupplyRequest();
                        
            
            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Number');
            }
            if (data.hasOwnProperty('amount')) {
                obj['amount'] = ApiClient.convertToType(data['amount'], 'Number');
            }
        }
        return obj;
    }

    /**
    * 給油時刻
    * @member {Number} timestamp
    */
    'timestamp' = undefined;
    /**
    * 給油量
    * @member {Number} amount
    */
    'amount' = undefined;




}
